<!-- Aside (Mobile Navigation) -->
<aside class="main-aside">
    <a class="navbar-brand" routerLink='/'> 
		<img src="{{logoImage}}" alt="logo"> 
	</a>

    <div class="aside-scroll">
      <ul>
        <li class="menu-item menu-item-has-children">
          <a routerLink='/'>Home  </a>
        </li>
        <li class="menu-item menu-item-has-children d-none">
          <a href="#">Pages</a>
          <ul class="submenu">
            <li class="menu-item"> <a routerLink='/about'>About Us</a> </li>
            <li class="menu-item"> <a routerLink='/login'>Login</a> </li>
            <li class="menu-item"> <a routerLink='/register'>Sign Up</a> </li>
            <li class="menu-item"> <a routerLink='/checkout'>Checkout</a> </li>
            <li class="menu-item"> <a routerLink='/cart'>Cart</a> </li>

            <li class="menu-item"> <a routerLink='/legal'>Legal</a> </li>
            <li class="menu-item"> <a href="404.html">Error 404</a> </li>
          </ul>
        </li>
       
        <li class="menu-item">
          <a routerLink='/login' *ngIf="!isLogout">Login</a>
        </li>
		<li class="menu-item">
          <a routerLink='/register' *ngIf="!isLogout">Signup</a>
        </li>
		<li class="menu-item" *ngIf="showGiftCardLink==='1'" >
          <a href="https://factor4.securetree.com/" target="_blank">Gift Card </a>
        </li> 
        <li class="menu-item">
          <a routerLink='/contact'>Contact Us</a>
        </li>
      </ul>

    </div>

  </aside>
  <div class="aside-overlay aside-trigger"></div>

  <!-- Header Start -->
  <header class="main-header header-1">

    <div class="top-header">
      <div class="container">
        <div class="top-header-inner">

          <div class="top-header-contacts">
            <ul class="top-header-nav">
              <li > <a class="p-0" href="tel:{{res_phone}}"><i class="fas fa-phone mr-2"></i> {{res_phone}}</a> </li>
            </ul>
          </div>

          <ul class="top-header-nav header-cta">
			<li *ngIf="isLogout">
			<ul class="navbar-nav login-user-navbar-ul" >
				<li class="nav-item dropdown">
				<a class="nav-link login-user-nav-link dropdown-toggle" href="#" id="navbarDropdownMenuLink" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
				  <img 
				  [src]="userImage"
				  id ="profileImage"
				  width="40" height="40" class="rounded-circle"
				  (error)="updateUrlInvalidProfile('http://ssl.gstatic.com/accounts/ui/avatar_2x.png')"
				  >
				</a>
				<div class="dropdown-menu login-user-dropdown-menu" aria-labelledby="navbarDropdownMenuLink" >
				  <a class="dropdown-item login-user-dropdown-item" routerLink='/orders' *ngIf="user_detail.id>1">My Orders</a>
				  <a class="dropdown-item login-user-dropdown-item" routerLink='/profile' *ngIf="user_detail.id>1">Profile</a>
				  <a class="dropdown-item login-user-dropdown-item" (click)="logOut()">Logout</a>
				</div>
			  </li>   
			</ul>
			</li>
		  </ul>

        </div>
      </div>
    </div>

    <div class="container">
      <nav class="navbar">
        <!-- Logo -->
        <a class="navbar-brand" routerLink='/'> 
			<img src="{{logoImage}}" alt="logo"> 
		</a>
        <!-- Menu -->
        <ul class="navbar-nav">
          <li class="menu-item menu-item-has-children">
            <a routerLink='/'>Home </a>
         
          </li>
          <li class="menu-item menu-item-has-children">
            <a routerLink='/login' *ngIf="!isLogout">Login</a>
          </li>
          <li class="menu-item">
            <a routerLink='/register' *ngIf="!isLogout">Signup</a>
          </li>
	   	<li class="menu-item" *ngIf="showGiftCardLink==='1'" >

          <a href="https://factor4.securetree.com/" target="_blank" >Gift Card</a>
        </li> 
          <li class="menu-item">
            <a routerLink='/contact'>Contact Us</a>
          </li>
        </ul>
        <div class="header-controls">
          <ul class="header-controls-inner">
            <li class="cart-dropdown-wrapper cart-trigger">
              <span class="cart-item-count">0</span>
              <i class="flaticon-shopping-bag"></i>
            </li>
            <li class="search-dropdown-wrapper search-trigger d-none">
              <i class="flaticon-search"></i>
            </li>
          </ul>
          <!-- Toggler -->
          <div class="aside-toggler aside-trigger">
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>

      </nav>
    </div>

  </header>
  <!-- Header End -->